import {createRequestTypes} from "./helpers";

export const PRODUCT_CMS_DATA = createRequestTypes("CMS:REQUEST_PRODUCT_CMS_DATA");
export const loadProductCmsData = (locale) => ({ type: PRODUCT_CMS_DATA.LOAD, locale });